import $ from 'jquery';
import 'lightgallery';
import { Swiper } from './swiper-src.min.js';
import { getDefaultSliderSettings } from '../utils/slider.js';

export default function initImageGallerySlider() {
  // Initialize LightGallery
  $('.gallery').lightGallery({});

  // Initialize Swiper for each gallery
  const gallerySlider = document.querySelector('.slider-gallery');
  const navSlider = document.querySelector(`.slider-nav`);

  if (!gallerySlider || !navSlider) return;

  var swiper = new Swiper(navSlider, {
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true
  });
  new Swiper(gallerySlider, {
    ...getDefaultSliderSettings(navSlider),
    spaceBetween: 10,
    thumbs: {
      swiper: swiper
    }
  });
}
